import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export const knmSearchMonthOptions: ISelectOption[] = [
  { id: '1', value: '1', label: 'Январь' },
  { id: '2', value: '2', label: 'Февраль' },
  { id: '3', value: '3', label: 'Март' },
  { id: '4', value: '4', label: 'Апрель' },
  { id: '5', value: '5', label: 'Май' },
  { id: '6', value: '6', label: 'Июнь' },
  { id: '7', value: '7', label: 'Июль' },
  { id: '8', value: '8', label: 'Август' },
  { id: '9', value: '9', label: 'Сентябрь' },
  { id: '10', value: '10', label: 'Октябрь' },
  { id: '11', value: '11', label: 'Ноябрь' },
  { id: '12', value: '12', label: 'Декабрь' },
];
